<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn name="ceshi" type="primary" size="large" roles="设备新增,设备编辑"  icon="search"  />  -->

      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="姓名">
              <a-input placeholder="请输入" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="手机号">
              <a-input placeholder="请输入" v-model="where.keyword.phone" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="分类">
              <a-select
                  show-search
                  v-model="where.keyword.form_type"
                  allowClear

              >
                <a-select-option value="内容生态合作伙伴" >内容生态合作伙伴</a-select-option>
                <a-select-option value="城市合伙人" >城市合伙人</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList" v-btnlimit="'学习统计-搜索'">搜索</a-button>
          </a-col>
        </a-row>

      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <a-table
          :columns="list.columns"
          rowKey="id"
          :scroll="{ x: 3000}"
          @change="onChange"
          :pagination="list.pagination"
          :dataSource="list.datas"
          :loading="isloading"
          :locale="{emptyText:'暂无数据'}"
      >

        <span slot="action" slot-scope="info">
          <pxkeji-btn name="备注" size="small" @click="showInfo(info)" type="primary" />
        </span>

      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>
    <a-modal
        title="备注"
        v-model="info.visible"
        width="60%"
        :footer="false"
        destroyOnClose
        :maskClosable="false"
    >
      <Info  @callbackMethod="complateMark" :id="info.id" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "@/views/leads/Info";
const columns = [
  {
    dataIndex: "company",
    key: "company",
    align: "center",
    title: "公司"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "姓名",
  },
  {
    dataIndex: "mobile",
    key: "mobile",
    align: "center",
    title: "手机号",
  },

  {
    dataIndex: "email",
    key: "email",
    align: "center",
    title: "邮箱"
  },
  {
    dataIndex: "form_type",
    key: "form_type",
    align: "center",
    title: "分类",
  },
  {
    dataIndex: "city",
    key: "city",
    align: "center",
    title: "城市"
  },
  {
    dataIndex:"type",
    key: "type",
    align: "center",
    title: "合作类型",
  },
  {
    dataIndex:"industry",
    key: "industry",
    align: "center",
    title: "擅长行业",
  },
  {
    dataIndex:"business",
    key: "business",
    align: "center",
    title: "主营业务",
  },
  {
    dataIndex:"resume",
    key: "resume",
    align: "center",
    title: "公司/个人优势",
  },
  {
    dataIndex:"mark",
    key: "mark",
    align: "center",
    title: "备注",
  },
  {
    dataIndex: "time",
    key: "time",
    align: "center",
    title: "提交时间"
  },

  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "index",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          pageNow:1,
          pageSize:50,
          name: "",
          phone: "",
          form_type:""
          // 2021 11 01 end
        }
      },
      info:{
        visible:false,
        id:0
      },
      isloading: false,
    };
  },
  components: {
    Info
  },
  mounted: function() {
    this.$nextTick(function() {

      this.GetList();
    });
  },
  watch: {

  },
  methods: {
    searchList() {
      this.list.pagination.current = 1;
      this.where.keyword.pageNow = 1;
      this.GetList();
    },
    // 2021 10 22 end
    onChange(p){
      this.list.pagination.current=p.current
      this.where.keyword.pageNow = p.current;
      this.GetList();
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.$api.leads
          .getDataPageList({
            name:this.where.keyword.name,
            phone:this.where.keyword.phone,
            form_type:this.where.keyword.form_type,
            pageNow:this.list.pagination.current,
            pageSize:this.list.pagination.defaultPageSize,
              }).then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.list.datas = res.data.records;
              this.list.pagination.total = Number(res.data.total);
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
    },

    //查看学习详情
    showInfo(info) {
      this.info.visible = true;
      this.info.id = info.id;
    },
    complateMark:function(){

      this.info.visible = false;
      this.info.id = 0;
      this.GetList();
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

